import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";

import AnalyticsAndHighlightImg from "../../assets/images/Home/AnalyticsAndHighlight.png";
import CommunicationAndAnnouncementsImg from "../../assets/images/Home/CommunicationAndAnnouncements.png";
import EmergingTalentsImg from "../../assets/images/Home/EmergingTalents.png";
import GlobalNetworkImg from "../../assets/images/Home/GlobalNetwork.png";
import StreamlinedFootballEventManagementImg from "../../assets/images/Home/StreamlinedFootballEventManagement.png";

import ManageClubSection from "./ManageClubSection";
import RegisterEntity from "./RegisterEntity";
import FAQSection from "./FAQSection";
import HomeFooter from "./HomeFooter";
import GlobalTalentSection from "./GlobalTalentSection";
import HeroSection from "./HeroSection";
import HomeNav from "./HomeNav";
import WaitingListSection from "./WaitingListSection";
import TypicalSection from "./TypicalSection";

const Home = () => {
  const { t } = useTranslation();

  const registerEntityRef = useRef<HTMLDivElement | null>(null);
  const scrollToRegisterEntity = () => {
    if (registerEntityRef.current) {
      registerEntityRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const waitingListRef = useRef<HTMLDivElement | null>(null);
  const scrollToWaitingList = () => {
    if (waitingListRef.current) {
      waitingListRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#000",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <HomeNav />
      <HeroSection scrollToRegisterEntity={scrollToRegisterEntity} scrollToWaitingList={scrollToWaitingList} />
      <WaitingListSection ref={waitingListRef} />
      <GlobalTalentSection scrollToRegisterEntity={scrollToRegisterEntity} />
      <TypicalSection
        heading={t("pages.home.analyticsAndInsights")}
        body={t("pages.home.gainInsights")}
        btnText={t("pages.home.requestDemo")}
        btnAction={scrollToRegisterEntity}
        sectionImg={AnalyticsAndHighlightImg}
      />
      <TypicalSection
        heading={t("pages.home.emergingTalentScouting")}
        body={t("pages.home.discoverAndRecruit")}
        btnText={t("pages.home.requestDemo")}
        btnAction={scrollToRegisterEntity}
        sectionImg={EmergingTalentsImg}
      />
      <TypicalSection
        heading={t("pages.home.globalNetworkBuilding")}
        body={t("pages.home.buildYourNetwork")}
        btnText={t("pages.home.requestDemo")}
        btnAction={scrollToRegisterEntity}
        sectionImg={GlobalNetworkImg}
      />
      <TypicalSection
        heading={t("pages.home.effortlessCommunication")}
        body={t("pages.home.easilyCommunicate")}
        btnText={t("pages.home.requestDemo")}
        btnAction={scrollToRegisterEntity}
        sectionImg={CommunicationAndAnnouncementsImg}
      />
      <TypicalSection
        heading={t("pages.home.streamlinedEventManagement")}
        body={t("pages.home.manageEventsEffortlessly")}
        btnText={t("pages.home.requestDemo")}
        btnAction={scrollToRegisterEntity}
        sectionImg={StreamlinedFootballEventManagementImg}
      />
      <ManageClubSection />
      <RegisterEntity ref={registerEntityRef} />
      <FAQSection />
      <HomeFooter />
    </Box>
  );
};

export default Home;
